import http from "./main";

export default {
  getAll: async (limit, page, filters) => {
    return await http.get(
      `/appointments?page=${page}&limit=${limit}&filters=${filters}`
    );
  },
  getById: async (id) => {
    return await http.get(`/appointments/${id}`);
  },
  getLatestForPatient: async (patientId, num) => {
    return await http.get(`appointments/latest/${patientId}/${num}`);
  },
};
